module.exports = __webpack_public_path__ + "img/fangdajing.c6442d32.png";